const images = {
  logo: 'https://vegetablesale.jp/assets/logo-02.png',
};

export {images};
